<template>
  <img class="logo" src="../assets/logo_alt.svg" alt="Vuecamp 2019 Logo" />
</template>

<script>
export default {
  name: "logo"
};
</script>

<style lang="scss"></style>
